import { render, staticRenderFns } from "./Callicon.vue?vue&type=template&id=11a398c8&scoped=true&"
var script = {}
import style0 from "./Callicon.vue?vue&type=style&index=0&id=11a398c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a398c8",
  null
  
)

export default component.exports